import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Link, Typography } from "@mui/material";
import { Trans } from "@lingui/macro";
import { useLogEvent } from "@/services/Analytics/useLogEvent";
import { ClickTarget, EventType, SourcePage } from "@/services/Analytics/EventTypes";

/** Asks for the wearable an athlete wants imported, under the vitals sources. */
function RequestWearablePrompt() {
  const navigate = useNavigate();
  const { logEvent } = useLogEvent();

  const openRequest = useCallback(() => {
    logEvent("request_wearable_link", {
      event_type: EventType.click,
      click_target: ClickTarget.request_it,
      source_page_name: SourcePage.authorized_apps,
    });
    navigate("/request-wearables");
  }, [logEvent, navigate]);

  return (
    <Box mt="auto" px={2} py={3} display="flex" justifyContent="center">
      <Typography variant="prose-sm" color="text.secondary" align="center">
        <Trans>
          Don&apos;t see your wearable?{" "}
          <Link
            component="button"
            variant="prose-sm"
            color="info.main"
            underline="none"
            onClick={openRequest}
            data-testid="request-wearable-prompt-link"
            sx={{ verticalAlign: "baseline" }}
          >
            Request it.
          </Link>
        </Trans>
      </Typography>
    </Box>
  );
}

export default RequestWearablePrompt;
